import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { DepositLimitUpdatePopupState } from 'src/domains/players/state/accountState/DepositLimitsUpdatePopups/DepositLimitUpdatePopup/DepositLimitUpdatePopup.state';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { PopupContentWithInput } from 'src/domains/players/state/accountState/DepositLimitsUpdatePopups/components/PopupContentWithInput/PopupContentWithInput';
import { UsersState } from 'src/domains/players/state/UsersState';
import { PopupWrapper } from 'src/domains/players/state/accountState/DepositLimitsUpdatePopups/components/PopupWrapper/PopupWrapper';
import { PopupContent } from 'src/domains/players/state/accountState/DepositLimitsUpdatePopups/components/PopupContent/PopupContent';

export const DepositLimitUpdatePopup = observer('DepositLimitUpdatePopup', (): JSX.Element | null => {
    const common = useCommon();
    const usersState = UsersState.get(common);
    const configComponents = ConfigComponents.get(common);
    const {
        config: { rollingNetDepositLimitFirstTimePopupType, accountHelperMail },
    } = configComponents;

    const [state] = useState(() => new DepositLimitUpdatePopupState(common));

    if (state.showDepositLimitPopup && usersState.isSrgModalOpen) {
        if (rollingNetDepositLimitFirstTimePopupType === 'secondary') {
            return (
                <PopupWrapper
                    state={state}
                    buttonVariant='submit'
                >
                    <PopupContent
                        variant='secondary'
                        accountHelperMail={accountHelperMail}
                    />
                </PopupWrapper>
            );
        }

        if (rollingNetDepositLimitFirstTimePopupType === 'tertiary') {
            return (
                <PopupWrapper
                    state={state}
                    version='tertiary'
                    buttonVariant='accept'
                >
                    <PopupContentWithInput configComponents={configComponents} />
                </PopupWrapper>
            );
        }

        return (
            <PopupWrapper
                state={state}
                buttonVariant='submit'
            >
                <PopupContent
                    variant='primary'
                    accountHelperMail={accountHelperMail}
                />
            </PopupWrapper>
        );
    }

    return null;
});
